import { defineComponent as f, ref as d, createElementBlock as n, openBlock as l, normalizeClass as s, unref as o, createVNode as a, createCommentVNode as m, withCtx as y } from "vue";
import { ScalarIconCopy as C, ScalarIconCheck as h } from "@scalar/icons";
import { cva as v, cx as i } from "@scalar/use-hooks/useBindCx";
import { useClipboard as b } from "@scalar/use-hooks/useClipboard";
import k from "../ScalarButton/ScalarButton.vue.js";
const g = {
  key: 0,
  role: "alert",
  class: "sr-only"
}, N = /* @__PURE__ */ f({
  __name: "ScalarCodeBlockCopy",
  props: {
    content: {},
    controls: {},
    class: {}
  },
  setup(t) {
    const { copyToClipboard: r } = b(), e = d(!1), u = async () => {
      if (e.value)
        return;
      const c = typeof t.content == "string" ? t.content : JSON.stringify(t.content, null, 2);
      await r(c), e.value = !0, setTimeout(() => {
        e.value = !1;
      }, 1200);
    }, p = v({
      base: "absolute top-0 right-0 h-8 w-8 p-0 flex items-center justify-center brightness-lifted bg-inherit rounded focus-visible:opacity-100 -outline-offset-1",
      variants: {
        showCopied: {
          true: "text-c-1",
          false: "text-c-3 hover:text-c-1"
        }
      }
    });
    return (c, x) => (l(), n("div", {
      class: s(
        o(i)(
          "scalar-code-copy opacity-0 group-hover/code-block:opacity-100 sticky flex inset-0 justify-end items-start bg-inherit",
          t.class
        )
      )
    }, [
      a(o(k), {
        class: s(o(i)(o(p)({ showCopied: e.value }))),
        type: "button",
        variant: "ghost",
        "aria-controls": c.controls,
        "aria-label": "Copy",
        onClick: u
      }, {
        default: y(() => [
          a(o(C), {
            class: s(["copy-icon size-4", { copied: e.value }])
          }, null, 8, ["class"]),
          a(o(h), {
            class: s(["check-icon size-4", { visible: e.value }])
          }, null, 8, ["class"])
        ]),
        _: 1
      }, 8, ["class", "aria-controls"]),
      e.value ? (l(), n("div", g, " Copied ")) : m("", !0)
    ], 2));
  }
});
export {
  N as default
};
